export function getTutorialVersions(path) {
  let context;
  switch (path) {
  case 'en':
    context = require.context('./en_US', false, /\.js$/);
    break;
  case 'zh_CN':
    context = require.context('./zh_CN', false, /\.js$/);
    break;
  default:
    context = require.context('./en_US', false, /\.js$/);
  }
  const versions = {};
  const keyss = context.keys();
  keyss.forEach(k => {
    if (k !== './index.js') {
      const match = k.match(/^\.\/((\w*\.)*\w*)\.js$/);
      if (!!match && match.length >= 1) {
        const version = match[1];
        versions[version] = context(k).default || context(k);
      }
    }
  });
  return versions;
}
